import type { InputProps } from '@/components'
import { Card, Input } from '@/components'
import { Input as BaseInput } from '@/components_deprecated'
import { Card as OldCard } from '@/components_deprecated/Card'
import { cn } from '@/lib/utils'
import { useParam, usePermissions } from '@/utils'
import { Loader } from '@ur-solutions/react-components'
import type { ReactNode } from 'react'
import { Suspense, type PropsWithChildren } from 'react'
import styled from 'styled-components'

export interface AreaProps {
  $area: string
}
export const Area = styled.div<AreaProps>`
  grid-area: ${props => props.$area};
`
export const InputArea = styled(Area)`
  display: flex;
  flex-direction: column;

  label {
    margin: 0 0 4px 4px;
    color: ${props => props.theme.colors.gray5};
    font-weight: 600;
  }
`
interface OldInputProps {
  editing: boolean
}
/** @deprecated Use ProfileInput */
export const OldInput = styled(BaseInput).attrs<OldInputProps>(
  ({ editing }: OldInputProps) => ({
    disabled: !editing,
    noBorders: !editing,
    background: editing ? 'white' : 'quaternary',
  })
)<OldInputProps>`
  height: 54px;

  input {
    font-weight: 500;
    -webkit-text-fill-color: ${props => props.theme.colors.text.dark};
    -webkit-opacity: 1;
    color: ${props => props.theme.colors.text.dark};

    opacity: 1;
  }
  i {
    color: ${props =>
      props.editing ? props.theme.colors.gray8 : props.theme.colors.secondary};
  }
`

interface ProfileInputProps extends InputProps {
  editing: boolean
}
export function ProfileInput({
  className,

  editing,

  ...props
}: ProfileInputProps) {
  return (
    <Input
      className={cn(
        'font-medium disabled:text-neutral-700',
        !editing && 'bg-quaternary border-none',
        className
      )}
      {...props}
      disabled={!editing || props.disabled}
    />
  )
}

/** @deprecated Use ProfileCardProps */
export interface OldProfileCardProps {
  $area?: string
}
/** @deprecated Use ProfileCard */
export const OldProfileCard = styled(OldCard)<OldProfileCardProps>`
  grid-area: ${props => props.$area};
  padding: 1.5rem;

  header {
    justify-content: flex-start !important;
    gap: 1rem;
  }

  ${props => props.theme.media.mobile} {
    padding: 1rem;
  }
`

interface ProfileCardProps extends PropsWithChildren {
  title?: ReactNode
  description?: ReactNode
  area?: string
  action?: ReactNode

  permissions?: string | string[]
  permissionsOrMe?: string | string[]
}

export function ProfileCard({
  children,
  title,
  description,
  area,
  action,

  permissions,
  permissionsOrMe,
}: ProfileCardProps) {
  const userId = useParam('userId')
  const { hasPermissions, hasPermissionsOrMe } = usePermissions()

  const fnPerm = !!permissionsOrMe
    ? (perms: string | string[]) => hasPermissionsOrMe({ id: userId }, ...perms)
    : hasPermissions
  const perms = permissionsOrMe ?? permissions

  if (!!perms && !fnPerm(perms)) return null

  return (
    <Card
      className={cn('p-4 md:p-6')}
      style={{ gridArea: area }}
      title={title}
      description={description}
      action={action}
    >
      <Suspense
        fallback={
          <div className="flex justify-center p-8">
            <Loader.Spinner size={24} />
          </div>
        }
      >
        {children}
      </Suspense>
    </Card>
  )
}
